export const prod = true;

export const url_prod = "https://service.tarastreado.com.br/";
export const url_homo = "http://service.hm.tarastreado.com.br/";

export const token = "adasrwet43yt57uuj6NjY4MUE4NDMtQTI0Qy00NUY1LUJFNzMtQkY4NjJDQkJBRkY5454637rgfvdsgreagretertertw23456";